export const TYPOGRAPHY = {
  FONT_FAMILY: 'Inter Variable, system-ui, sans-serif',

  FONT_SIZE: {
    XS: '0.75rem', // 12px
    SM: '0.875rem', // 14px - base size
    BASE: '1rem', // 16px
    MD: '1.125rem', // 18px
    LG: '1.25rem', // 20px
    XL: '1.375rem', // 22px
  },

  LINE_HEIGHT: {
    XS: '1.125rem', // 18px
    SM: '1.313rem',
    BASE: '1.5rem',
    MD: '1.375rem',
    LG: '1.75rem',
    XL: '2rem',
  },

  FONT_WEIGHT: {
    REGULAR: 450,
    MEDIUM: 550,
    SEMIBOLD: 650,
  },
} as const;
